<div class="loader-wrapper brand-dashboard">
  <app-campaign-dashboard-stats-section
    *ngIf="insights"
    [insights]="insights"
  />
  <section *ngIf="insights">
    <div class="brand-dashboard-charts-loader" *ngIf="loadingLinearChartsData">
      <app-loader
        [text]="'brand.campaign.dashboard.loadingCharts' | translate"
        [ngClass]="{ visible: loadingLinearChartsData }"
      />
    </div>
    <app-campaign-dashboard-daily-charts
      *ngIf="
        showNewCharts() && insights && insightCharts && !loadingLinearChartsData
      "
      [insightCharts]="insightCharts"
      [insights]="insights"
    />
    <ng-container *ngIf="!showNewCharts()">
      <section *ngIf="insights.googleAdsStats" class="brand-dashboard-info">
        <h3>{{ "brand.campaign.dashboard.googleAds" | translate }}</h3>
        <div class="statistics brand-dashboard-info-card">
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.googleAdsStats.impressions | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.impressions" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.googleAdsStats.views | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.reach" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.googleAdsStats.conversions | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.conversions" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.googleAdsStats.linkClicks | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.clicks" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ campaign.currencySymbol
              }}{{ insights.googleAdsStats.spend | number: "1.0-2" }}
            </p>
            <p class="type">
              {{ "brand.campaign.dashboard.budgetSpent" | translate }}
            </p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ campaign.currencySymbol
              }}{{ insights.googleAdsBudget | number: "1.0-2" }}
            </p>
            <p class="type">
              {{ "brand.campaign.dashboard.totalBudget" | translate }}
            </p>
          </div>
        </div>
      </section>
      <section *ngIf="insights.facebookAdsStats" class="brand-dashboard-info">
        <h3>
          {{ "brand.campaign.dashboard.facebookInstagramAds" | translate }}
        </h3>
        <div class="statistics brand-dashboard-info-card">
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.facebookAdsStats.impressions | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.impressions" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.facebookAdsStats.views | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.reach" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{
                insights.facebookAdsStats.inlinePostEngagement | number: "1.0-2"
              }}
            </p>
            <p class="type">{{ "shared.engagement" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.facebookAdsStats.linkClicks | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.clicks" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ campaign.currencySymbol
              }}{{ insights.facebookAdsStats.spend | number: "1.0-2" }}
            </p>
            <p class="type">
              {{ "brand.campaign.dashboard.budgetSpent" | translate }}
            </p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ campaign.currencySymbol
              }}{{ insights.facebookAdsBudget | number: "1.0-2" }}
            </p>
            <p class="type">
              {{ "brand.campaign.dashboard.totalBudget" | translate }}
            </p>
          </div>
        </div>
      </section>
      <section *ngIf="insights.facebookPostsStats" class="brand-dashboard-info">
        <h3>{{ "brand.campaign.dashboard.facebookPosts" | translate }}</h3>
        <div class="statistics brand-dashboard-info-card">
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.facebookPostsStats.impressions | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.views" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.facebookPostsStats.likes | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.likes" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.facebookPostsStats.comments | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.comments" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.facebookPostsStats.shares | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.shares" | translate }}</p>
          </div>
          <div class="statistic-param-chart">
            <p class="amount">
              {{ insights.facebookPostsStats.clicks | number: "1.0-2" }}
            </p>
            <p class="type">{{ "shared.clicks" | translate }}</p>
          </div>
          <div class="statistic-param-chart statistic-param--hidden">
            <p class="amount">000</p>
            <p class="type">Type</p>
          </div>
        </div>
      </section>
    </ng-container>
  </section>
  <app-loader
    [text]="'shared.loadingCampaign' | translate"
    [ngClass]="{ visible: loadingStatsData }"
  />
</div>
